function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import olFormatGeoJSON from 'ol/format/GeoJSON';
import olFeature from 'ol/Feature';
import olRenderFeature from 'ol/render/Feature';
import { fromExtent } from 'ol/geom/Polygon';
import { processFeatureProperties } from '../../../mapwfs2/plugin/WfsVectorLayerPlugin/util/props';
var featureFormatter = new olFormatGeoJSON();
/**
 * @method getGeojsonFromOlFeature
 *
 * Returns geojson feature collection for feature.
 * If the feature is read-only (olRenderFeature), the geometry of GeoJSON feature is the feature's extent.
 *
 * @param {olFeature | olRenderFeature} feature
 * @return geojson FeatureCollection
 */
export var getFeatureAsFeatureCollection = function getFeatureAsFeatureCollection(feature) {
  if (feature instanceof olRenderFeature) {
    var polygon = fromExtent(feature.getExtent());
    var ftr = new olFeature(polygon);
    ftr.setProperties(feature.getProperties());
    return featureFormatter.writeFeaturesObject([ftr]);
  } else {
    return featureFormatter.writeFeaturesObject([feature]);
  }
};

/**
 * @method getGeojsonFromOlFeature
 *
 * Transforms OpenLayers feature object to a GeoJSON feature.
 * If the feature is read-only (olRenderFeature), the geometry of GeoJSON feature is the feature's extent.
 *
 * @param {olFeature | olRenderFeature} feature
 * @return geojson Feature
 */
export var getFeatureAsGeojson = function getFeatureAsGeojson(olFeature) {
  var featureCollection = getFeatureAsFeatureCollection(olFeature);
  if (!featureCollection || !featureCollection.features || !featureCollection.features.length) {
    return null;
  }
  var feature = featureCollection.features[0];
  return _objectSpread(_objectSpread({}, feature), {}, {
    properties: processFeatureProperties(feature.properties)
  });
};